import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  patients:false,
  dashboard:false,
  tasks:false,
  "case-days":false,
  reports:false,
  registry:false,
  management:false,
  communication:false,
  sidebarCollapsed:false,
};

const collapseSlice = createSlice({
  name: 'collapseValues',
  initialState,
  reducers: {
    open(state,action) {
      if(action.payload.management===true || action.payload.management===false){
        state.management = action.payload.management;
      }
      if(action.payload.communication===true || action.payload.communication===false){
        state.communication = action.payload.communication;
      }
      if(action.payload.patients===true || action.payload.patients===false)
        state.patients = action.payload.patients;
      if(action.payload.dashboard===true || action.payload.dashboard===false)
        state.dashboard = action.payload.dashboard;
        if(action.payload.tasks===true || action.payload.tasks===false)
        state.tasks = action.payload.tasks;
      if(action.payload["case-days"]===true || action.payload["case-days"]===false)
        state["case-days"] = action.payload["case-days"];
      if(action.payload.reports===true || action.payload.reports===false)
        state.reports = action.payload.reports;
      if(action.payload.registry===true || action.payload.registry===false)
        state.registry = action.payload.registry;
      if (action.payload.sidebarCollapsed !== undefined) {
        state.sidebarCollapsed = action.payload.sidebarCollapsed;
      }
    },
  },
});

export const { open } = collapseSlice.actions;
export default collapseSlice.reducer;